// extracted by mini-css-extract-plugin
export default {"displayBox":"ChangeAgentModal_displayBox__UJbB6","displayData":"ChangeAgentModal_displayData__IW2r8"};